import { MediaLayer } from "./MediaLayer";
import type { GalleryData } from "./schemas";

export default function Gallery(props: GalleryData) {
  const items = props.items ?? [];
  const layout = props.layout ?? "grid";

  if (layout === "strip") {
    return (
      <section className="gallery-zoom-lock relative w-full bg-background py-10">
        <div className="gallery-zoom-lock flex gap-3 overflow-x-auto px-6 no-scrollbar snap-x snap-mandatory">
          {items.map((it, i) => (
            <figure
              key={i}
              className="relative shrink-0 w-[70vw] max-w-[420px] aspect-[3/4] rounded-xl overflow-hidden snap-start bg-muted"
            >
              <MediaLayer media={it.media} alt={it.caption || `image ${i + 1}`} />
              {it.caption && (
                <figcaption className="absolute inset-x-0 bottom-0 px-4 pb-3 text-xs text-foreground/85 text-shadow-soft bg-gradient-to-t from-black/60 to-transparent pt-8">
                  {it.caption}
                </figcaption>
              )}
            </figure>
          ))}
        </div>
      </section>
    );
  }

  const gridClass =
    layout === "masonry"
      ? "columns-2 md:columns-3 gap-3 [&>figure]:mb-3 [&>figure]:break-inside-avoid"
      : "grid grid-cols-2 md:grid-cols-3 gap-3";

  return (
    <section className="gallery-zoom-lock relative w-full bg-background py-10 px-4">
      <div className={`gallery-zoom-lock max-w-5xl mx-auto ${gridClass}`}>
        {items.map((it, i) => (
          <figure
            key={i}
            className={`relative rounded-xl overflow-hidden bg-muted ${
              layout === "grid" ? "aspect-square" : ""
            }`}
          >
            <MediaLayer media={it.media} alt={it.caption || `image ${i + 1}`} />
            {it.caption && (
              <figcaption className="absolute inset-x-0 bottom-0 px-3 pb-2 text-[11px] text-foreground/85 text-shadow-soft bg-gradient-to-t from-black/60 to-transparent pt-6">
                {it.caption}
              </figcaption>
            )}
          </figure>
        ))}
      </div>
    </section>
  );
}
